import Swal from "sweetalert2";
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import { Spinner } from 'react-bootstrap';
import DeleteIcon from 'mdi-react/DeleteIcon';
import React, { useState, useEffect } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorGreenHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  svg:hover {
    fill: ${colorGreenHover};
  }

  .orange-hover:hover {
    fill: #e9c886;
  }

  .red-hover:hover {
    fill: #e98686;
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const ProvidersList = (props) => {
    const [showLoader, setShowLoader] = useState(true);
    const [providersList, setProvidersList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: true,
        placeholder: 'Search...',
    };

    const handleEdit = (provider) => {
        props.setSelectedProvider(provider)
    }

    const handleDelete = (provider) => {
        Swal.fire({
            title: 'Warning!',
            text: `Do you want to delete the provider ${provider.name}?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.deleteProvider(provider.id).then(() => {
                    withReactContent(Swal).fire({
                        title: "Success",
                        html: "Provider is deleted!",
                    });
                    props.setListRequiresReload(true);
                }).catch((error) => {
                    withReactContent(Swal).fire({
                        title: "Error",
                        html: error.response.data?.detail,
                    });
                })
            }
        })
    }

    const GetProviders = () => {
        setShowLoader(true);
        AdminInterface.instance.getProviders().then((response) => {
            const columns = [
                {
                    accessor: 'id',
                    Header: 'Id',
                },
                {
                    accessor: 'name',
                    Header: 'Name',
                },
                {
                    accessor: 'description',
                    Header: 'Description',
                },
                {
                    accessor: 'url',
                    Header: 'URL',
                    disableSortBy: true,
                    disableGlobalFilter: true,
                },
                {
                    accessor: 'edit',
                    Header: 'Edit',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                },
                {
                    accessor: 'delete',
                    Header: 'Delete',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                }
            ];
            const data = [];
            response.data.forEach(provider => {
                data.push({
                    id: provider.id,
                    name: provider.name,
                    description: provider.description,
                    url: <a href={provider.url} target="_blank">{provider.url}</a>,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(provider)}><EditIcon className="orange-hover"/></CartTableButton>,
                    delete: <CartTableButton type="button" onClick={() => handleDelete(provider)}><DeleteIcon className="red-hover"/></CartTableButton>,
                });
            });

            setProvidersList({ tableHeaderData: columns, tableRowsData: data });
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        }).finally(() => {
            setShowLoader(false);
            props.setListRequiresReload(false);
        });
    }

    useEffect(() => {
        GetProviders();
    }, [props.listRequiresReload]);

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Providers List</CardTitle>
                </CardTitleWrap>
                {
                    !showLoader &&
                    <ReactTableBase columns={providersList.tableHeaderData} data={providersList.tableRowsData} tableConfig={tableConfig} />
                }
                {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
            </CardBody>
        </Card>
    );
};

export default ProvidersList;